import moment from 'moment';

const SgiFormTimeEO = function () {
    return {
        alwBlk: true,
        // c:"desId",
        ctlH: 0,
        ctlN: "时间控件",
        ctlW: 24,
        // defVal10:moment('12:08:23', 'HH:mm:ss'), //传入的是moment对象
        desId: "EP_EO_UI_3105",
        isDis: false,
        isHdn: false,
        lblW: 6,
        te: "时间",

        isLbl: false,
        lblAlg: "right",
        inpPopTe: "请选择时间",
        // csstyle:"time-default", // 自定义css样式
        // mgn:"10",
        // pad:"20",
        // msfTgt:"qtip",
        // isRead:false,
        hourStep: 1, // 微调的时间间距：原平台为step
        minuteStep: 1, // 微调的时间间距
        secondStep: 1, // 微调的时间间距

        // isSrp:true, //键盘过滤状态
        // maxL:20, //不需要
        // minL:0, //不需要
        // isGw:false, //延伸状态
        // n:"描述GUID",
        // sNo:10,
        // t:"time",
        // useTim:0,
        // visible:true,
        // x:"0",
        // y:"0",
    }
}

export { SgiFormTimeEO };
export default SgiFormTimeEO;



// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCompEO/SgiFormTimeEO.js